import React from 'react';
import { Typography } from '@mui/material';
import ScheduleBox from './ScheduleBox';
import { EDIT_FIELDS } from '../constants/editJobConstants';

const ScheduleDisplay = ({ 
  reservation,
  editingField,
  reservationEditData,
  setReservationEditData,
  onEditField,
  onSaveEdit,
  onCancelEdit
}) => {
  return (
    <div className="bg-gray-50 p-2 lg:p-5 rounded-lg border border-gray-200 shadow-sm">
      <Typography variant="subtitle1" className="text-gray-800 font-medium mb-3">
        Schedule
      </Typography>
      
      <div className="grid grid-cols-2 gap-3 lg:gap-6">
        <ScheduleBox 
          type={EDIT_FIELDS.CHECKIN}
          reservation={reservation}
          editingField={editingField}
          reservationEditData={reservationEditData}
          setReservationEditData={setReservationEditData}
          onEdit={onEditField}
          onSave={onSaveEdit}
          onCancel={onCancelEdit}
        />
        
        <ScheduleBox 
          type={EDIT_FIELDS.CHECKOUT}
          reservation={reservation}
          editingField={editingField}
          reservationEditData={reservationEditData}
          setReservationEditData={setReservationEditData}
          onEdit={onEditField}
          onSave={onSaveEdit}
          onCancel={onCancelEdit}
        />
      </div>

      {/* Override indicator */}
      {reservation?.has_time_override && (
        <div className="mt-3 p-2 bg-blue-50 text-blue-700 text-sm rounded border border-blue-100 flex items-center">
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className="h-4 w-4 mr-2 flex-shrink-0" 
            viewBox="0 0 20 20" 
            fill="currentColor"
          >
            <path 
              fillRule="evenodd" 
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" 
              clipRule="evenodd" 
            />
          </svg>
          <span>This reservation has time overrides set</span>
        </div>
      )}
    </div>
  );
};

export default ScheduleDisplay;